import { Persona } from '@fluentui/react';
import { Facepile, Icon, IFacepilePersona, OverflowButtonType, PersonaSize } from '@fluentui/react';
import React from 'react';

interface IGridListIconFormat {
  formField: any;
  width?: number;
}

const iconStyles = {
  root: {
    fontWeight: 'bold',
    fontSize: '20px',
  },
};

const GridListIconFormat = (props: IGridListIconFormat) => {
  console.log(props)
  const format = (formField: any) => {
    console.log(formField);
    if (formField == true) {
      return (
        <span style={{ width: `${props.width}px`, display: 'inline-block' }} className="text-center">
          <Icon iconName="SkypeCircleCheck" className="color-success" styles={iconStyles} />
        </span>
      );
    } else if (formField == 'dontShow') {
      return <></>;
    } else {
      return (
        <span style={{ width: `${props.width}px`, display: 'inline-block' }} className="text-center">
          <Icon iconName="Cancel" className="color-error" styles={iconStyles} />
        </span>
      );
    }
  };

  return format(props.formField);
};

export default GridListIconFormat;

export const ActiveIconFormat = (isActive: boolean) => {
  return (
    <span>
      <Icon iconName="LocationFill" className={isActive ? 'active-color' : 'inactive-color'}></Icon>
    </span>
  );
};

export const ActivoIconFormat = (isActive: boolean) => {
  return (
    <span
      style={{
        width: '100%',
        textAlign: 'center',
        paddingRight: 12,
      }}
    >
      <Icon
        iconName={isActive ? 'SkypeCircleCheck' : 'Cancel'}
        className={isActive ? 'active-color' : 'inactive-color'}
      ></Icon>
    </span>
  );
};

export const RamaIconFormat = (gender: string) => {
  return (
    <span>
      <Icon
        iconName="Contact"
        className={gender === 'M' ? 'rama-icon male-icon' : 'rama-icon female-icon'}
        title={gender === 'M' ? 'Masculino' : 'Femenino'}
      ></Icon>
    </span>
  );
};

// Lista de colores predefinidos
// Función para obtener un número de 1 a 24 basado en las iniciales
export const getColorIndexFromInitials = (initials: string) => {
  let hash = 0;

  // Convertir las iniciales a un valor hash
  for (let i = 0; i < initials.length; i++) {
    hash = initials.charCodeAt(i) + ((hash << 5) - hash);
  }

  // Asegurarse de que el valor del hash sea positivo
  hash = Math.abs(hash);

  // Obtener un valor entre 1 y 24
  const colorIndex = (hash % 24) + 1;
  if ((colorIndex >= 20 && colorIndex <= 22) || colorIndex == 15) return 1;
  if (colorIndex == 11) return 18;
  return colorIndex;
};

// Lista de colores predefinidos
// Función para obtener un número de 1 a 24 basado en las iniciales
export const getColorIndexFromPase = (paseLabel: string) => {
  let hash = 0;

  // Convertir las iniciales a un valor hash
  for (let i = 0; i < paseLabel.length; i++) {
    hash = paseLabel.charCodeAt(i) + ((hash << 4) - hash);
  }

  // Asegurarse de que el valor del hash sea positivo
  hash = Math.abs(hash);

  // Obtener un valor entre 1 y 24
  const colorIndex = (hash % 24) + 1;
  if ((colorIndex >= 20 && colorIndex <= 22) || colorIndex == 15) return 1;
  if (colorIndex == 11) return 18;
  return colorIndex;
};

// Función para obtener un número de 1 a 24 basado en las iniciales
export const getColorIndexFromTribunal = (paseLabel: string) => {
  let hash = 0;

  // Convertir las iniciales a un valor hash
  for (let i = 0; i < paseLabel.length; i++) {
    hash = paseLabel.charCodeAt(i) + ((hash << 3) - hash);
  }

  // Asegurarse de que el valor del hash sea positivo
  hash = Math.abs(hash);

  // Obtener un valor entre 1 y 24
  const colorIndex = (hash % 24) + 1;
  if ((colorIndex >= 20 && colorIndex <= 22) || colorIndex == 15) return 1;
  if (colorIndex == 11) return 18;
  return colorIndex;
};

export const CategoriaIconFormat = (categoria: string, size?: PersonaSize) => {
  const categoria_parseada = categoria ? categoria : '';

  const initials = categoria_parseada.slice(0, 3).toLocaleUpperCase();
  const color = getColorIndexFromInitials(categoria_parseada);

  const personas: IFacepilePersona[] = [
    {
      imageInitials: initials,
      personaName: categoria_parseada,
      data: categoria_parseada,
      initialsColor: color, // Asigna el color generado
    },
  ];

  return (
    <span>
      <Facepile
        personas={personas} // Pasamos la lista de personas
        maxDisplayablePersonas={1} // Mostrar solo 1 item
        overflowButtonType={OverflowButtonType.none} // No mostrar botón de desbordamiento
        onRenderPersona={(props) => (
          <Persona
            {...props}
            size={size ? size : PersonaSize.size24}
            onRenderPrimaryText={() => <></>}
          ></Persona>
        )}
      />
    </span>
  );
};
